export default "__VITE_ASSET__HeNQCE0K__"